import { IDestroyOptions } from "@pixi/display";
import { ICanvasScaler } from "by/gamefactory/canvas/ICanvasScaler";
import { PromiseCompletionSource } from "scene-manager";
import { BaseView } from "scene-manager";
import { Sprite } from "@pixi/sprite";
import { LoseSceneResourcesPackage } from "../resources/LoseSceneResourcesPackage";
import { LoseController } from "../controller/LoseController";
import { Texture } from "@pixi/core";
import { Localization } from "../../common/Localization";
import { AudioManager } from "../../../audio/AudioManager";
import { PinkTextStyle } from "../resources/LoseTextStyles";
import { FitText } from "../../common/components/FitText";
import { IFocusable } from "../../../layers/IFocusable";

export class BaseLoseSceneView extends BaseView<void> implements IFocusable {
    public readonly focusable: boolean = true;
    protected background: Sprite;
    protected restartText: FitText;

    public constructor(
        protected readonly canvasScaler: ICanvasScaler,
        protected readonly backgroundTexture: Texture,
        protected readonly loseSceneResourcesPackage: LoseSceneResourcesPackage,
        protected readonly loseController: LoseController,
        protected readonly localization: Localization,
        protected readonly audioManager: AudioManager,
        operationControls: PromiseCompletionSource<void>
    ) {
        super(operationControls);
        this.build();
        this.layout();
        this.subscribe();
        this.eventMode = "static";
    }

    protected subscribe(): void {
        this.canvasScaler.onResize.add(this.onResize, this);
        this.on("pointerup", this.onRestartClick, this);
    }

    protected unsubscribe(): void {
        this.canvasScaler.onResize.remove(this.onResize, this);
        this.off("pointerup", this.onRestartClick, this);
    }

    public override start(): void { }

    protected build(): void {
        this.background = new Sprite(this.backgroundTexture);
        this.restartText = new FitText(this.localization.getText("tap_to_restart"), new PinkTextStyle(100), 830, 150);
        this.addChild(this.background, this.restartText);
    }

    protected onRestartClick(): void {
        this.loseController.continue();
        this.operationControls.complete();
    }

    protected layout() {
        const { referenceWidth, referenceHeight } = this.canvasScaler;
        this.background.height = referenceHeight;
        this.background.scale.x = this.background.scale.y;
        this.background.position.x = (referenceWidth - this.background.width) * 0.5;
        this.restartText.position.set((referenceWidth - this.restartText.width) * 0.5, 1620);
    }

    protected onResize() {
        this.layout();
    }

    public override destroy(options?: IDestroyOptions | boolean): void {
        this.unsubscribe();
        super.destroy(options);
    }
}
